export default function Tagline() {
  return (
    <section className="relative bg-primary-500 py-20 md:py-32 overflow-hidden">
      {/* Folded paper texture as main background layer */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url("https://storage.helloreaddy.io/project_files/8cf86b48-d09c-4ec8-816e-12bbed2b078b/20fe5440-07c0-4fbd-b363-5cc0eddf6c08_compressed_Folded-Paper-Texture-17.webp")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.55,
          mixBlendMode: 'multiply',
          filter: 'grayscale(1)',
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-foreground-50 tracking-tighter leading-[0.9]"
        >
          REKLAM ÖLMEDİ.
          <br />
          <span className="text-foreground-300">SENİN REKLAMIN ÖLDÜ.</span>
        </h2>
        <p className="mt-6 md:mt-8 text-base md:text-lg text-foreground-50/60 font-medium max-w-xl mx-auto">
          Farkı görmek için hazır mısın?
        </p>
        <div className="mt-8 md:mt-12">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-foreground-50 border-2 border-foreground-50/60 rounded-full px-10 py-4 text-base font-bold hover:bg-foreground-50 hover:text-primary-500 transition-all duration-300 tracking-widest uppercase"
            style={{ textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}
          >
            BİZİ ARA
            <i className="ri-arrow-right-line text-lg" />
          </a>
        </div>
      </div>
    </section>
  );
}